module.exports = __webpack_public_path__ + "static/media/hero-img2.22827a5d.png";